export default "__VITE_ASSET__b96368e0__"